// ─── helpers ──────────────────────────────────────────

/**
 * Formats milliseconds to human readable due string.
 * @param {number} ms
 * @returns {string}
 */
export const _formatDue = (ms) => {
    const totalMin = Math.floor(ms / 60000);
    if (totalMin < 60) return `${totalMin}m`;
    const h = Math.floor(totalMin / 60);
    const d = Math.floor(h / 24);
    if (d > 0) return `${d}d ${h % 24}h`;
    return `${h}h`;
};

// ─── sx ──────────────────────────────────────────

/**
 * Card border/glow/animation. ringing drives whether the ring animation runs
 * at all; danger (event.isRinging() — overdue or reminder time passed) picks
 * red vs blue for the ring color. Pulse stays in the same color throughout —
 * no white flash on the 50% keyframe.
 * No cursor here — drag cursor lives only on titlebarSx.
 * @param {boolean} ringing
 * @param {boolean} selected
 * @param {boolean} danger
 */
export const cardSx = (ringing, selected, danger) => {
    const ringColor = danger ? 'var(--j-danger)' : 'var(--j-accent)';
    const ringGlow = danger ? 'rgba(255,107,107,' : 'rgba(102,178,255,';

    // 3D depth layers, los van de ring-glow: inset highlight (boven, simuleert
    // licht van boven) + gelaagde drop shadows (zachte verre schaduw + scherpe
    // contactschaduw dichtbij). Ring-glow komt er als eigen 0 0 0 Npx laag bovenop.
    const depthShadow = '0 1px 0 rgba(255,255,255,0.07) inset, 0 6px 16px rgba(0,0,0,0.55), 0 2px 4px rgba(0,0,0,0.4)';

    return {
        width: 148,
        background: 'linear-gradient(180deg, #283950 0%, #1e2d42 100%)',
        border: `1px solid ${ringing ? ringColor : selected ? '#5d87ab' : '#294766'}`,
        borderTop: `1px solid ${ringing ? ringColor : selected ? '#5d87ab' : '#4a6788'}`,
        borderRadius: '3px',
        overflow: 'hidden',
        boxShadow: ringing
            ? `${depthShadow}, 0 0 0 2px ${ringGlow}0.2)`
            : selected
              ? `${depthShadow}, 0 0 0 1px rgba(133,183,235,0.18)`
              : depthShadow,
        ...(ringing && {
            animation: 'calRing 1s ease-in-out infinite',
            '@keyframes calRing': {
                '0%,100%': { borderColor: ringColor, boxShadow: `${depthShadow}, 0 0 0 2px ${ringGlow}0.2)` },
                '50%': { borderColor: ringColor, boxShadow: `${depthShadow}, 0 0 0 4px ${ringGlow}0.5)` },
            },
        }),
    };
};

export const titlebarSx = {
    background: 'linear-gradient(180deg, #0a5694 0%, #05407a 100%)',
    borderBottom: '1px solid var(--j-border-color)',
    // px: '1px',
    pr: '4px',
    py: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'grab',
};

export const catSx = {
    fontSize: 10,
    fontWeight: 500,
    color: 'var(--j-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
};

export const bodySx = {
    px: '7px',
    py: '6px',
};

export const labelSx = {
    fontSize: 12,
    fontWeight: 500,
    color: 'var(--j-text)',

    mb: '3px',
};

export const descSx = {
    fontSize: 11,
    fontWeight: 400,
    color: 'var(--j-text)',
    mb: '5px',
    cursor: 'default',
};

export const rowSx = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    mb: '3px',
};

export const iconSx = {
    fontSize: 11,
    color: 'var(--j-muted)',
};

export const metaSx = {
    fontSize: 11,
    color: 'var(--j-muted)',
};

export const dividerSx = {
    borderTop: '0.5px solid var(--j-border-color)',
    my: '5px',
};

export const dismissRowSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    mt: '5px',
    // cursor: 'pointer',
    // '&:hover': { '& .MuiTypography-root, & svg': { color: 'var(--j-danger)' } },
};

export const dismissLabelSx = {
    fontSize: 11,
    justifyContent: 'flex-end',
    color: 'var(--j-danger)',
    cursor: 'pointer',
    '&:hover': { '& .MuiTypography-root, & svg': { color: 'var(--j-danger)' } },
};
